export enum RenderMode {
  REGULAR = 'REGULAR',
  PRELOAD = 'PRELOAD',
  HIDDEN = 'HIDDEN',
}
